module.exports = __webpack_public_path__ + "static/media/mic_off.0de60d2d.svg";